// extracted by mini-css-extract-plugin
export default {"wrap":"Modal_wrap__P0Cyp","content":"Modal_content__yBmFf","closeButton":"Modal_closeButton__3V9B-","title":"Modal_title__KuCmT"};